import {DropdownTreeSelect} from 'components/Generic/DropdownTreeSelect/DropdownTreeSelect';
import {type TreeSelection} from 'components/Generic/DropdownTreeSelect/AssignTree';
import useParseURL from 'hooks/useParseURL';
import {useGetPlanTreeNavigation} from 'hooks/swr';

interface MultiCageSelectorProps {
  setSelected: (selection: TreeSelection) => void;
  selected: TreeSelection;
  disabled?: boolean;
  dataTestId?: string;
}

export const MultiCageSelector = ({selected, setSelected, disabled, dataTestId}: MultiCageSelectorProps) => {
  const {planId} = useParseURL();
  const {data: planTreeNavigation} = useGetPlanTreeNavigation({resourceId: planId});

  return (
    planTreeNavigation && (
      <DropdownTreeSelect
        data={planTreeNavigation}
        selected={selected}
        setSelected={setSelected}
        disabled={disabled}
        dataTestId={dataTestId}
      />
    )
  );
};
